"use client";
import Slider from "react-slick";

export default Slider;
